import axios from "axios";
import { Base_URL } from "../url";

export const saveItemDetails = async (itemData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Item/ItemMaster?UserName=${userName}`,
      itemData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save Item";
  }
};
export const fetchAllItems = async () => {
  const res = await axios.get(`${Base_URL}/Item/ItemGetData`);
  return res.data;
};
export const fetchMerchantCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetAllMerchants`);
    return response.data.map(merchant => ({
      code: merchant.merchantCode,
      name: merchant.merchantName
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch merchant codes";
  }
};

export const fetchManufacturers = async () => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetManufacturers`);
    return response.data.map(manufacturer => ({
      code: manufacturer.merchantCode,
      name: manufacturer.merchantName
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch manufacturers";
  }
};

export const fetchCountryCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data.map(country => ({
      code: country.countryCode,
      name: country.countryName
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch country codes";
  }
};

export const fetchRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/RegionMaster/GetRegionsByCountry`,
      { countryCode }
    );
    return response.data.map(region => ({
      code: region.regionCode,
      name: region.regionName
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch regions by country";
  }
};

export const fetchItemTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemTypeMaster/GetAllItemTypes`);
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item types";
  }
};
// ../Api/Item.js - Add this function
export const fetchItemGroupsByItemType = async (itemType) => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroupMaster/item-description?item_code=${itemType}`);
    return response.data.map(group => ({
      code: group.code,
      description: group.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item groups by item type";
  }
};
export const fetchSKUUnits = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UnitMaster/GetAllUnits`);
    console.log(response.data);
    return response.data.map(unit => ({
      code: unit.code,
      description: unit.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch SKU units";
  }
};

export const fetchItemGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemGroupMaster/GetAllItemGroups`);
    return response.data.map(group => ({
      code: group.code,
      description: group.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item groups";
  }
};

export const fetchItemGroups1ByItemGroupCode = async (itemGroupCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup1/GetItemGroupsByItemGroupCode`,
      { itemGroupCode }
    );
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item group 1";
  }
};

export const fetchItemGroups2ByItemGroup1 = async (itemGroup1) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup2/GetItemGroups2ByItemGroup1`,
      { itemGroup1 }
    );
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item group 2";
  }
};

export const fetchItemGroups3ByItemGroup2 = async (itemGroup2) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ItemGroup3/GetItemGroups3ByItemGroup2`,
      { itemGroup2 }
    );
    return response.data.map(item => ({
      code: item.code,
      description: item.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch item group 3";
  }
};

export const fetchValuationMethods = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ValuationMethod/GetAllValuationMethods`);
    return response.data.map(method => ({
      code: method.code,
      description: method.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch valuation methods";
  }
};

export const fetchTaxCategories = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TaxCategory/GetAllTaxCategories`);
    return response.data.map(category => ({
      code: category.code,
      description: category.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch tax categories";
  }
};

export const fetchWeightUnits = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UnitMaster/GetAllUnits`);
    return response.data.map(unit => ({
      code: unit.code,
      type: unit.type
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch weight units";
  }
};

export const fetchWarehouses = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    return response.data.map(office => ({
      code: office.officeCode,
      name: office.officeName
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch warehouses";
  }
};

export const fetchBrandGroups = async () => {
  try {
    const response = await axios.get(`${Base_URL}/BrandGroup/GetAllBrandGroups`);
    return response.data.map(brandGroup => ({
      code: brandGroup.brandCode,
      description: brandGroup.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch brand groups";
  }
};

export const fetchBrandsByGroup = async (brandGroupCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Brand/GetBrandsByGroup`,
      { brandGroupCode }
    );
    return response.data.map(brand => ({
      code: brand.code,
      description: brand.description
    }));
  } catch (error) {
    throw error.response?.data || "Failed to fetch brands";
  }
};